import React, { useState } from 'react';
import {
    Typography,
    Button,
    TextField,
    Grid,
    Fab,
    Hidden,
    styled,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import { useAuth0 } from '@auth0/auth0-react';
import { teacherFeedback } from '../../redux/BookingSlice';
import { useDispatch } from 'react-redux';
import LimitedTextField from '../BasicComponents/LimitedTextField';
import axios from 'axios';

const Root = styled('form')(({ theme }) => ({
    margin: theme.spacing(1),
}));

const FabSpaced = styled(Fab)(({ theme }) => ({
    margin: theme.spacing(2),
}));

const ReportText = styled(TextField)(({ theme }) => ({
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
}));

const textLength = 100;

export const TeacherCompleted = props => {
    const dispatch = useDispatch();

    const [state, setState] = useState({
        uploadingState: 'Not Started',
        sessions: [{}],
    });

    const { getAccessTokenSilently } = useAuth0();

    const addClass = () => {
        var interimSessions = state.sessions;
        if (interimSessions.length < 8) {
            interimSessions.push({});
            setState({
                ...state,
                sessions: interimSessions,
            });
        }
    };

    const removeClass = (event, i) => {
        let interimSessions = state.sessions;
        interimSessions.splice(i, 1);
        setState({
            ...state,
            sessions: interimSessions,
        });
        console.log('state: ', state);
    };

    const handleChange = event => {
        setState({
            ...state,
            [event.target.id]: event.target.value,
        });
    };

    const handleChangeSession = (event, i) => {
        var interimSessions = state.sessions;
        interimSessions[i][event.target.id] = event.target.value;
        setState({
            ...state,
            sessions: interimSessions,
        });
    };

    const handleSubmission = async () => {
        const token = await getAccessTokenSilently({
            scope: process.env.REACT_APP_scope,
        });
        setState({
            ...state,
            uploadingState: 'Writing to Booking',
        });
        try {
            const document = {
                sk1: props.sk1,
                values: state,
            };
            await axios
                .post('/uploadTeacherBookingReport', document, {
                    baseURL: process.env.REACT_APP_API_GATEWAY,
                    timeout: 30000,
                    headers: {
                        authorization: `Bearer ${token}`,
                    },
                })
                .then(permission => {
                    setState({
                        ...state,
                        uploadingState: 'Completed',
                    });
                    dispatch(
                        teacherFeedback({
                            feedback: permission.data.Message.Data.values,
                            id: props.id,
                        })
                    );
                })
                .catch(err => {
                    console.log('apiError', err.response.status);
                    if (err.response.status === 406) {
                        setState({
                            ...state,
                            uploadingState:
                                'Failed Validation. Please remove special characters',
                        });
                    } else {
                        setState({
                            ...state,
                            uploadingState: 'Failed',
                        });
                    }
                });
        } catch (err) {
            console.log(err);
            setState({
                ...state,
                uploadingState: 'Failed',
            });
        }
    };

    if (props.status === 'Approved') {
        return (
            <div>
                <Root>
                    <Hidden only={['xs']}>
                        <Typography variant="h2" color="secondary">
                            End of Shift Report
                        </Typography>
                    </Hidden>
                    <Hidden only={['sm', 'md', 'lg', 'xl']}>
                        <Typography variant="h4" color="secondary">
                            Shift Report
                        </Typography>
                    </Hidden>

                    <ReportText
                        id="teachername"
                        data-cy="teacher-name"
                        variant="outlined"
                        label="Name of Teacher Replaced"
                        value={state.teachername}
                        onChange={handleChange}
                        fullWidth
                        disabled={
                            state.uploadingState === 'Completed' ||
                            state.uploadingState === 'Writing to Booking'
                        }
                        inputProps={{ maxLength: textLength }}
                    />

                    {state.sessions.map((session, index) => {
                        return (
                            <Grid container>
                                <Grid item xs={1}>
                                    <Typography
                                        variant="h3"
                                        sx={{ paddingTop: 1 }}
                                        data-cy="class-num"
                                    >
                                        {index + 1}
                                    </Typography>
                                </Grid>
                                <Grid item xs={11}>
                                    <ReportText
                                        id="classname"
                                        data-cy="class-name"
                                        value={
                                            typeof session.classname !==
                                            'undefined'
                                                ? session.classname
                                                : ''
                                        }
                                        variant="outlined"
                                        label="Class Name/Subject"
                                        onChange={e =>
                                            handleChangeSession(e, index)
                                        }
                                        fullWidth
                                        disabled={
                                            state.uploadingState ===
                                                'Completed' ||
                                            state.uploadingState ===
                                                'Writing to Booking'
                                        }
                                        inputProps={{ maxLength: textLength }}
                                    />

                                    <ReportText
                                        id="session"
                                        data-cy="session"
                                        value={
                                            typeof session.session !==
                                            'undefined'
                                                ? session.session
                                                : ''
                                        }
                                        variant="outlined"
                                        label="Period / Session"
                                        onChange={e =>
                                            handleChangeSession(e, index)
                                        }
                                        fullWidth
                                        disabled={
                                            state.uploadingState ===
                                                'Completed' ||
                                            state.uploadingState ===
                                                'Writing to Booking'
                                        }
                                        inputProps={{ maxLength: textLength }}
                                    />
                                    <LimitedTextField
                                        label="notes"
                                        data-cy="notes"
                                        disabled={
                                            state.uploadingState ===
                                                'Completed' ||
                                            state.uploadingState ===
                                                'Writing to Booking'
                                        }
                                        textLength={1500}
                                        width="100%"
                                        value={
                                            typeof session.notes !== 'undefined'
                                                ? session.notes
                                                : ''
                                        }
                                        updateField={e =>
                                            handleChangeSession(e, index)
                                        }
                                    />
                                    {/* <ReportText
                                        id="notes"
                                        value={state.sessions[index]['notes']}
                                        variant="outlined"
                                        label="Notes"
                                        onChange={e =>
                                            handleChangeSession(e, index)
                                        }
                                        multiline
                                        fullWidth
                                        disabled={
                                            state.uploadingState ===
                                                'Completed' ||
                                            state.uploadingState ===
                                                'Writing to Booking'
                                        }
                                    /> */}
                                    <div
                                        style={{
                                            display: 'flex',
                                            justifyContent: 'right',
                                        }}
                                    >
                                        <Button
                                            variant="outlined"
                                            startIcon={<DeleteIcon />}
                                            onClick={e => {
                                                removeClass(e, index);
                                            }}
                                            data-cy="remove-class"
                                        >
                                            Remove
                                        </Button>
                                    </div>
                                </Grid>{' '}
                            </Grid>
                        );
                    })}
                    <Typography variant="h5">
                        <FabSpaced
                            color="primary"
                            onClick={addClass}
                            disabled={
                                state.uploadingState === 'Completed' ||
                                state.uploadingState === 'Writing to Booking' ||
                                state.sessions.length === 8
                            }
                            data-cy="add-class"
                        >
                            <AddIcon />
                        </FabSpaced>
                        Add Class Info
                    </Typography>
                    <LimitedTextField
                        id="followup"
                        data-cy="follow-up"
                        label="Things to follow up"
                        disabled={
                            state.uploadingState === 'Completed' ||
                            state.uploadingState === 'Writing to Booking'
                        }
                        textLength={1500}
                        width="100%"
                        value={state.followup}
                        updateField={handleChange}
                    />
                    <LimitedTextField
                        id="behaviour"
                        data-cy="behaviour"
                        label="Behaviour Management"
                        disabled={
                            state.uploadingState === 'Completed' ||
                            state.uploadingState === 'Writing to Booking'
                        }
                        textLength={1500}
                        width="100%"
                        value={state.behaviour}
                        updateField={handleChange}
                    />
                    {/* <ReportText
                        id="followup"
                        label="Things to follow up"
                        variant="outlined"
                        value={state.followup}
                        onChange={handleChange}
                        multiline
                        fullWidth
                        disabled={
                            state.uploadingState === 'Completed' ||
                            state.uploadingState === 'Writing to Booking'
                        }
                        inputProps={{ maxLength: textLength }}
                    />
                    <ReportText
                        id="behaviour"
                        label="Behaviour Management"
                        variant="outlined"
                        value={state.behaviour}
                        onChange={handleChange}
                        multiline
                        fullWidth
                        disabled={
                            state.uploadingState === 'Completed' ||
                            state.uploadingState === 'Writing to Booking'
                        }
                        inputProps={{ maxLength: textLength }}
                    /> */}
                    <Button
                        variant="contained"
                        onClick={handleSubmission}
                        sx={{ m: 1 }}
                        data-cy="submit"
                    >
                        Submit
                    </Button>
                    <Typography variant="body2" sx={{ m: 1 }}>
                        Progress: {state.uploadingState}
                    </Typography>
                </Root>
            </div>
        );
    } else {
        return (
            <div>
                <Typography variant="h4">Pre-booking Data uploaded</Typography>
            </div>
        );
    }
};

export default TeacherCompleted;
